import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DateService } from 'src/app/shared/service/date.service';
import { FeeService } from 'src/app/shared/service/fee.service';
import { FeeChartModel } from 'src/app/shared/models/fee.chart.model';
import { ChartConfiguration, ChartData } from 'chart.js';
import { SubSink } from 'subsink';
import Swal from 'sweetalert2';
import { HttpError } from 'src/app/shared/models/http-error.model';
import { DateFormatPipe } from 'src/app/shared/pipes/jdate.pipe';
import { DecimalPipe } from '@angular/common';
import Big from 'big.js';
import {utils,write as xlsWrite} from 'xlsx';
@Component({
  selector: 'app-fee',
  templateUrl: './fee.component.html',
  styleUrls: ['./fee.component.scss']
})
export class FeeComponent implements OnInit, OnDestroy {
  total: number = 0;
  @Input() userId!: number;
  private sub = new SubSink();
  loading = false;
  errors!: any;
  feeChartModel!: FeeChartModel[];
  chartLabel!: string[];
  chartData: ChartData = {
    datasets: [],
    labels: []
  };
  lineChartColors: any[] = [
    {
      borderColor: '#7CEB91',
      backgroundColor: '#7CEB910B'
    }
  ];

  chartOptions: ChartConfiguration['options'] = {
    responsive: true,
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: '#FFF',
          font: {
            family: 'IRANSans_FaNum'
          }
        }
      },
      y: {
        stacked: true,
        ticks: {
          color: '#FFF',
          font: {
            family: 'IRANSans_FaNum'
          },
          callback: (value, index, values): any => {
            return this.decimalPipe.transform(value, '1.0-0');
          }
        }
      }
    },
    plugins: {
      legend: {
        labels: {
          color: '#FFF',
          usePointStyle: false
        },
        position: 'right'
      },
      tooltip: {
        titleFont: {
          family: 'IRANSans_FaNum',
          size: 16
        },
        bodyFont: {
          family: 'IRANSans_FaNum',
          size: 16
        },
        footerFont: {
          family: 'IRANSans_FaNum',
          size: 16
        },

        titleMarginBottom: 12,
        rtl: true,
        bodyAlign: 'right',
        bodySpacing: 8,
        callbacks: {
          title: (item): any => {
            return item[0].label;
          },
          label: (item): any => {
            const label: string = item.dataset.label ?? '';

            return (
              label +
                '‏ :' +
                this.decimalPipe.transform(item.dataset.data[item.dataIndex]?.toString(), '1.0-0') +
                ' تومان' || ''
            );
          },
          footer: (item): string | string[] => {
            let total = 0;
            this.chartData.datasets.forEach((currentItem) => {
              total += Number(currentItem.data[item[0].dataIndex]);
            });
            return 'مجموع: ' + this.decimalPipe.transform(total, '1.0-0') + ' تومان ';
          }
        }
      }
    }
  };

  Toast = Swal.mixin({
    toast: true,
    position: 'bottom-start',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  constructor(
    private feeService: FeeService,
    private dateService: DateService,
    private decimalPipe: DecimalPipe,
    private dateFormatPipe: DateFormatPipe
  ) {}

  exportExcel(){
    const currenciesName = this.feeChartModel.map(currencyFee => currencyFee.currency.id)
    const sheetArray:any = [['تاریخ',...currenciesName]]
    console.log(sheetArray)
    sheetArray.push(...this.feeChartModel[0].fees.map((fee)=>{
      return [
        this.dateFormatPipe.transform(fee.date, 'jYYYY/jMM/jDD'),
      ];
    }))
    for(const currencyFee of this.feeChartModel){
      for (const [index,fee] of currencyFee.fees.entries()){
        if (Array.isArray(sheetArray[index+1])){
          sheetArray[index+1].push(Big(fee.totalPrice).times(Big(fee.irrPrice).div(10)).round().toNumber())
        }
      }
    }
    const workBook = utils.book_new();
    const sheet =  utils.aoa_to_sheet(sheetArray);
    utils.book_append_sheet(workBook, sheet, 'کارمزدها');
    let buffer = xlsWrite(workBook, { bookType: 'xlsx', compression: true, type: 'buffer' });
    let blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    let link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = "fName.xlsx";
    link.click();
    URL.revokeObjectURL(link.href);



  }

  getFeeHistory(dates: any = {}): void {
    if (!dates.startDate) {
      dates.startDate = this.dateService.previousWeek();
    }
    if (!dates.endDate) {
      dates.endDate = this.dateService.todayStringGregorian();
    }
    this.errors = {};
    this.loading = true;
    const workbook = utils.book_new();

    this.sub.sink = this.feeService
      .getFeeHistory(dates.startDate, dates.endDate, this.userId)
      .subscribe(
        (data) => {
          this.feeChartModel = data;
          this.chartData = {
            datasets: [],
            labels: []
          };



          this.lineChartColors = [];
          for (const q of this.feeChartModel) {
            this.chartData.datasets.push({
              data: q.fees
                .reverse()
                .map((hist) =>
                  Big(hist.totalPrice).times(Big(hist.irrPrice).div(10)).round().toNumber()
                ),
              backgroundColor: q.currency.color,
              label: q.currency.id
            });
            this.chartData.labels = q.fees.map((hist) =>
              this.dateFormatPipe.transform(hist.date, 'jYYYY/jMM/jDD')
            );
          }
          this.total = 0;
          this.chartData.datasets.forEach((item) => {
            item.data.forEach((dataInMonth) => {
              this.total += Number(dataInMonth);
            });
          });
          this.loading = false;
        },
        (error: HttpError) => {
          this.loading = false;
          if (error.status !== 422) {
            this.Toast.fire({ icon: 'error', title: error.error });
          } else {
            this.errors = error.validationError;
          }
        }
      );
  }

  ngOnInit(): void {
    this.getFeeHistory();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
